import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Cookies from "js-cookie";

const AIAssistant = () => {
  const user = useSelector((state) => state.user);
  const token = Cookies.get("token");
  
  // Build the URL with token parameter if user is authenticated
  const iframeUrl = useMemo(() => {
    const baseUrl = "https://api.wadhifety.com/ai-chat-login.html";
    
    // Check if user is signed in and has a token
    if (user?.authenticated && (user.token || token)) {
      const userToken = user.token || token;
      return `${baseUrl}?token=${userToken}`;
    }
    
    return baseUrl;
  }, [user?.authenticated, user?.token, token]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 70px)", // Account for app bar height
        border: "none",
      }}
    >
      <iframe
        src={iframeUrl}
        title="AI Assistant"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "8px",
        }}
        allow="microphone; camera"
        loading="lazy"
      />
    </Box>
  );
};

export default AIAssistant; 